import Surveys from '../surveys/Surveys.vue';
import Notifications from '../notifications/Notifications.vue';
import Carousel from '../../../sharedComponents/carousel/Carousel.vue';
import statusColors from '../../../utils/status-colors';

export default {
  data() {
    return {
      initializingProfile: null,
      initializedProfile: null,
      pagePers: null,
      pageRules: null,
      dialogPers: false,
      dialogRules: false,
      checkedPers: false,
    };
  },
  components: {
    Surveys,
    Notifications,
    Carousel,
  },
  computed: {
    readyProfile() {
      const { state, getters } = this.$store;
      // API опросов вернёт 403, пока профиль не подтверждён администратором.
      return state.settingsReady && getters.isApproved
        ? this.user.profile_id : null;
    },
    user() {
      return this.$store.state.user;
    },
    requirePers() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_pers === true
          && state.user
          && !state.user.pers_at
      );
    },
    requireRules() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_rules === true
        && state.user
        && this.$store.state.agreedRules === false
      );
    },
    account() {
      return this.user ? this.user.account : null;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userIsChecked() { return this.$store.state.user ? this.$store.state.user.is_checked : null; },
    isBlocked() {
      return !!(this.$store.state.user
        && this.$store.state.user.blocked_at !== null);
    },
    hasSurvey() {
      return this.$store.state.surveys.hasSurvey;
    },
    hasNotifications() {
      return this.$store.state.notifications.hasNotifications;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    banners() {
      return this.$store.state.banners.bannersList || [];
    },
    taxes() {
      return this.$store.state.settings.taxes === true;
    },
  },
  methods: {
    async initialize(id) {
      if (this.initializingProfile === id || this.initializedProfile === id) return;
      this.initializingProfile = id;
      try {
        await Promise.all([
          this.$store.dispatch('surveys/GetSurveys', id),
          this.$store.dispatch('notifications/GetNotifications', id),
          this.$store.dispatch('CheckAgreedRules').then(() => {
            if (this.user && this.user.profile_id === id
              && (this.requirePers || this.requireRules)) return this.LoadPers();
            return null;
          }),
        ]);
        this.initializedProfile = id;
      } catch (error) {
        this.$store.dispatch('HandleError', error);
      } finally {
        this.initializingProfile = null;
      }
    },
    GetColor: statusColors,
    async ConfirmPers() {
      try {
        await this.$store.getters.axl.post('profiles/api/auth/confirm-pers', {
          profile_id: this.user.profile_id,
        });
        await this.$store.dispatch('GetProfile');
      } catch (error) {
        this.$store.dispatch('HandleError', error);
      }
    },
    LoadPers() {
      return this.$store.getters.ax.post('profiles/api/register/info', { phone: this.user.phone_mobile })
        .then((response) => {
          this.pagePers = response.data.pagePers;
          this.pageRules = response.data.pageRules;
        });
    },
    ConfirmRules() {
      this.$store.dispatch('AgreeingRules');
    },
  },
  watch: {
    readyProfile: {
      immediate: true,
      handler(id) { if (id) this.initialize(id); },
    },
  },
};
